<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
          {{form.applications[0].department}}<br/>
          {{form.applications[0].campaign}}<br/>
          {{form.applications[0].subCampaign}}<br/>
          {{form.amount}}
            <PaymentForm>
                <FormSection title="Payment Details">
                   <FormRow inline>
                   <FormCol field="firstName" readonly />
                    <FormCol field="lastName" readonly/>
                  </FormRow>                
                  <FormRow inline>
                    <FormCol field="email" readonly />
                    <FormCol field="phone" readonly/>
                  </FormRow>  
                  <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>                                  
                </FormSection>
               <FormSection title="Payment Information">
                <FormRow inline>
                  <FormCol field="card" :showLabel="false" />
                </FormRow>
               </FormSection>
                <FormSection title="Billing Information" last>
                    <DonorAddress />
                </FormSection>
                <FormRow>
                    <PaymentButton/>
                </FormRow>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import type { Pledge } from '~/shared/pledge-form'

export default defineComponent({
  props: {
    pledge: {
      type: Object as PropType<Pledge>
    }
  },
  setup() {
    const { form } = usePaymentForm()

    return {
      form
    }
  },
})
</script>
